/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
export type PdpSharedBlurbSupportNumber_user$ref = any;
export type PdpSharedBlurbSupportNumber_user = {
    readonly isVerifiedTrade: boolean | null;
    readonly isVip: boolean | null;
    readonly " $refType": PdpSharedBlurbSupportNumber_user$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "PdpSharedBlurbSupportNumber_user",
    "type": "User",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
        {
            "kind": "ScalarField",
            "alias": null,
            "name": "isVerifiedTrade",
            "args": null,
            "storageKey": null
        },
        {
            "kind": "ScalarField",
            "alias": null,
            "name": "isVip",
            "args": null,
            "storageKey": null
        }
    ]
} as any);
(node as any).hash = '05e320a10721568dbcde1ad8b3e99e61';
export default node;
